import axios from 'axios';
import Vue from 'vue';
import {store} from './store';
import VueMask from 'v-mask';
import JoinFormComponent from "./components/JoinFormComponent.vue";
import SurnameResearchComponent from "./components/SurnameResearchComponent.vue";
import FormComponent from "./components/FormComponent.vue";
import DonationFormComponent from "./components/DonationFormComponent.vue";
import StoreCheckoutComponent from "./components/StoreCheckoutComponent.vue";
import LibraryComponent from "./components/LibraryComponent.vue";
import QueryDeskComponent from "./components/QueryDeskComponent.vue";
import BallotVoteComponent from "./components/BallotVoteComponent.vue";
import MemberComponent from "./components/MemberComponent.vue";
import EmptyOption from "./mixins/emptyOption";
import ArticlesComponent from "./components/ArticlesComponent.vue";
import DataSetComponent from "./components/DataSetComponent.vue";
import FilePreviewGrid from "./components/FilePreviewGrid.vue";
import LookupTableComponent from "./components/LookupTableComponent.vue";
import queryStore from './store/query';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Vue.prototype.$api = axios;
Vue.prototype.$api.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Vue.prototype.$api.defaults.headers.common['Content-Type'] = 'application/json';
Vue.prototype.$api.defaults.headers.common['Accept'] = 'application/json';

if (window.safeData.isAuth && window.safeData.isAuth === '1' && window.safeData.authToken) {
    Vue.prototype.$api.defaults.headers.common['Authorization'] = 'Bearer ' + window.safeData.authToken;
}

Vue.prototype.$api.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/';
Vue.prototype.$api.interceptors.request.use((config) => {
    return config;
});
Vue.prototype.$api.interceptors.response.use(
    function (response) {
        return response
    },
    function (error) {
        store.commit('SET_ERROR_DATA', error.response.data.errors);

        return Promise.reject(error)
    }
);

Vue.mixin({
    computed: {
        errors() {
            return this.$store.getters.errors;
        }
    },
    methods: {
        messageFieldError(field) {
            if (this.errors[field]) {
                return this.errors[field];
            }

            return '';
        },
        clearErrors() {
            store.commit('SET_ERROR_DATA', {});
        }
    }
});

Vue.mixin(EmptyOption);

Vue.component('join-form-component', JoinFormComponent);
Vue.component('surname-research-component', SurnameResearchComponent);
Vue.component('form-component', FormComponent);
Vue.component('donation-form-component', DonationFormComponent);
Vue.component('store-checkout-component', StoreCheckoutComponent);
Vue.component('member-component', MemberComponent);
Vue.component('articles-component', ArticlesComponent );
Vue.component('library-component', LibraryComponent);
Vue.component('query-desk-component', QueryDeskComponent);
Vue.component('ballot-vote-component', BallotVoteComponent);
Vue.component('data-set-component', DataSetComponent);
Vue.component('file-preview-grid', FilePreviewGrid);
Vue.component('lookup-table-component', LookupTableComponent);

Vue.use(VueMask);
Vue.use(queryStore);

const app = new Vue({
    el: '#content',
    store,

    //> Fixed the bug: Vue removes <style></style> from template after document loaded
    styleTagNodeList: [],
    created() {
        this.styleTagNodeList = document.querySelector(this.$options.el).querySelectorAll('style');
    },
    mounted() {
        for (let i = 0; i < this.styleTagNodeList.length; ++i)
            this.$el.appendChild(this.styleTagNodeList[i]);
    }
    //< Fixed the bug
});
